import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sub_page_con wrap_1120 mypage_inqury" }
const _hoisted_2 = { class: "search_wrap" }
const _hoisted_3 = { class: "btn_wrap _default float_right _board_type" }
const _hoisted_4 = { class: "open_board con_board sub_page_con_view" }
const _hoisted_5 = { class: "thead_li" }
const _hoisted_6 = { class: "tr_div con_tit" }
const _hoisted_7 = { class: "tb_chk checkbox_wrap2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "tb_no" }
const _hoisted_11 = { class: "tb_subject" }
const _hoisted_12 = { class: "elips_1" }
const _hoisted_13 = { class: "tb_date_hour" }
const _hoisted_14 = { class: "con_desc" }
const _hoisted_15 = { class: "con_q" }
const _hoisted_16 = { class: "con_a" }
const _hoisted_17 = { class: "con_date" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "_flex _flex_100 _jc_sb" }
const _hoisted_20 = { class: "tb_subject" }
const _hoisted_21 = { class: "elips_1" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "m_option_wrap" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "tb_date_hour" }
const _hoisted_26 = { class: "con_desc" }
const _hoisted_27 = { class: "con_q" }
const _hoisted_28 = { class: "con_a" }
const _hoisted_29 = { class: "con_date" }
const _hoisted_30 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.searchText) = $event)),
          onKeyup: [
            _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)), ["enter"])),
            _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
          ],
          placeholder: "검색어를 입력하세요."
        }, null, 544), [
          [_vModelText, $setup.state.searchText]
        ]),
        _createElementVNode("button", {
          class: "search_btn icon_wrap",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            src: "img/search_btn.png",
            alt: ""
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (!$setup.state.isMobile)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "common_btn _gray",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
            }, "삭제"))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: "javascript:void(0)",
          class: "common_btn w_130",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.push('/inquiryWrite')))
        }, "글쓰기")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.checkAll) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggleAll()))
                }, null, 544), [
                  [_vModelCheckbox, $setup.state.checkAll]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("em", null, null, -1))
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "tb_no" }, "번호", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "tb_subject" }, "제목", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tb_date_hour" }, "날짜", -1))
            ])
          ]),
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["tbody_li", [index === $setup.openIndex ? 'active' : '']]),
                  key: item.idx
                }, [
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", {
                          class: "tr_div con_tit",
                          onClick: ($event: any) => ($setup.toggle(index))
                        }, [
                          _createElementVNode("div", {
                            class: "tb_chk checkbox_wrap2",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.checkedList) = $event)),
                              value: item.idx,
                              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                            }, null, 8, _hoisted_9), [
                              [_vModelCheckbox, $setup.state.checkedList]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (index + 1)), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("u", null, _toDisplayString(item.title), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["ans_complete", { waiting: item.state !== 1 }])
                            }, _toDisplayString(item.state === 1 ? "답변완료" : "답변대기"), 3)
                          ]),
                          _createElementVNode("div", _hoisted_13, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                        ], 8, _hoisted_8),
                        _createVNode(_Transition, { name: "collapse" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", null, "내용", -1)),
                                _createElementVNode("div", null, _toDisplayString(item.content), 1)
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _cache[17] || (_cache[17] = _createElementVNode("span", null, "답변", -1)),
                                _createElementVNode("div", null, _toDisplayString(item.state === 1 ? item.comment : "답변 대기 중입니다."), 1),
                                _createElementVNode("p", _hoisted_17, _toDisplayString(item.state === 1 ? $setup.CommonUtils.dateFormat(new Date(item.answerDate), ".", true) : ""), 1)
                              ])
                            ], 512), [
                              [_vShow, $setup.openIndex === index]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", {
                          class: "tr_div con_tit small_txt",
                          onClick: ($event: any) => ($setup.toggle(index))
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("u", null, _toDisplayString(item.title), 1)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["ans_complete", { waiting: item.state !== 1 }])
                              }, _toDisplayString(item.state === 1 ? "답변완료" : "답변대기"), 3)
                            ]),
                            _createElementVNode("button", {
                              class: "m_option_btn icon_wrap only_768",
                              onClick: ($event: any) => ($setup.optionOpen(item))
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("img", {
                                src: "img/kebabIcon.png",
                                class: ""
                              }, null, -1)
                            ]))], 8, _hoisted_22),
                            _withDirectives(_createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "_gray",
                                onClick: ($event: any) => ($setup.optionClose(item))
                              }, "삭제", 8, _hoisted_24)
                            ], 512), [
                              [_vShow, $setup.state.isShowBtn && $setup.state.list_idx === item.idx]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                        ], 8, _hoisted_18),
                        _createVNode(_Transition, { name: "collapse" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _cache[19] || (_cache[19] = _createElementVNode("span", null, "내용", -1)),
                                _createElementVNode("div", null, _toDisplayString(item.content), 1)
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _cache[20] || (_cache[20] = _createElementVNode("span", null, "답변", -1)),
                                _createElementVNode("div", null, _toDisplayString(item.state === 1 ? item.comment : "답변 대기 중입니다."), 1),
                                _createElementVNode("p", _hoisted_29, _toDisplayString(item.state === 1 ? $setup.CommonUtils.dateFormat(new Date(item.answerDate), ".", true) : ""), 1)
                              ])
                            ], 512), [
                              [_vShow, $setup.openIndex === index]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ], 64))
                ], 2))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_30, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "tr_div" }, [
                  _createElementVNode("div", {
                    class: "tb_subject",
                    style: {"text-align":"center","width":"100%"}
                  }, "등록된 게시물이 없습니다.")
                ], -1)
              ]))]))
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 0,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}